window.cheatcode;
$(document).ready(function(){
    cheatcode="12345678";
    $(window).on('keydown',function(e) {
    if(e.key != undefined){
        cheatcode=cheatcode.substr(1,8);
        cheatcode+=(e.key).substr(0,1);
        if(cheatcode.toUpperCase()=="CREDITOS"){
            alert("CREDITOS\n(programacion) Jahaziel Aaron Aguilera Castillo\n(programacion) Jose Luis Ramirez Morales\n(diseno) Nadia Ortiz Corsa");
        }else if(cheatcode.toUpperCase()=="JUEGUITO"){
            // algun dia
        }
    }
    });
});